import axios from 'axios'
import router from './router'
import { store } from './store.js';

let previousRequest;
let cancel;
let cancelMessage;
let Interval
let exportRequest;
const CancelToken = axios.CancelToken;
let baseURL = window.apiUrl + '/v1/admin/';

String.prototype.trimChars = function (c) {
    var re = new RegExp("^[" + c + "]+|[" + c + "]+$", "g");
    return this.replace(re,"");
}

/*
let path = window.location.pathname.trimChars('/').split( '/' )
path = path && path[0] ? '/' + path[0] : ''
*/
window.useScopeSlugUrl = false;

window.intervalNotice = null;
window.axios = axios;
window.axios.defaults.baseURL = baseURL;
window.axios.interceptors.request.use(function(config){

    config.cancelToken = new CancelToken(function executor(c) {

        //console.log("CONFIG", previousRequest, exportRequest, config.url)

        var regEx = 'query=[A-z0-9\\_\\%\\-\\.\\@\\/\\s]*';
        var querySearch = config.url.match(regEx);

        if( config.url == previousRequest || (config.url.indexOf('query') > 0 && config.url.indexOf('/export') < 0) || (config.url == exportRequest) ){
            console.log("CANCEL", previousRequest, config.url, exportRequest)
            cancel = c;
            cancelMessage = config.url;
        }

        if( config.url.indexOf('/export') >= 0 ){
            exportRequest = config.url
        }

        previousRequest = config.url

    })


    if( config.url.indexOf('/import') >= 0 || config.url.indexOf('/stats') >= 0 ){
        // No loader
        $("#loader").stop().hide();
    }else if( config.url.indexOf('/export') >= 0 ){
        // No loader
        $("#loader").stop().hide();
        $("#weebox-export-inprogress").stop().fadeIn();
    }else{

        //$("#loader").fadeIn(180);
        /*
        $("#loader").fadeIn(180);
        setTimeout(function(){
            $("#loader").fadeOut(180);
        }, 180000);
        */
    }

    //console.log("config", config)

    config.headers['Authorization'] =  'Bearer ' + localStorage.getItem('token')
    config.headers['Accept'] =  'application/json'
    config.headers['X-WEEBOX-CLIENT'] =  localStorage.getItem('client')?localStorage.getItem('client'):document.head.querySelector("[name='X-WEEBOX-CLIENT']").content
    config.headers['X-WEEBOX-BACKEND'] =  true
    config.headers['Accept-Language'] =  'fr-CH'

    if( useScopeSlugUrl ){

        let scope_id = config && config.data && config.data.scope_id ? config.data.scope_id : null

        //console.log("COMPARE SCOPE", scope_id, store.state.scope.id)
        //console.log("SCOPES", store.state.scopes);

        if( scope_id != null && scope_id != store.state.scope.id ){
            let ressource = config.url.split('/v1/admin/')[1];
            if( store.state.scopes[scope_id] ){
                //console.log("use another slug for url", store.state.scopes[scope_id].slug )
                config.url = window.apiUrl + '/' + store.state.scopes[scope_id].slug + '/v1/admin/' + ressource;
            }
        }

    }

    return config;
})

window.axios.interceptors.response.use(function(response) {


    if( response.config.url.indexOf('/export') >= 0 ){
        $("#weebox-export-inprogress").stop().hide();
    }

    if( response.config.method != 'options' ){

        //console.log("response.config", response.config)

        $("#loader").stop().fadeOut(300);

        if( response.config && response.config.data && (typeof response.config.data === 'string' || response.config.data instanceof String) && response.config.data.indexOf('_axioMessageSuccess') >= 0 ){

            $("#weebox-notice-success").fadeIn(100);
            $("#weebox-notice-success").addClass('saved');
            clearInterval(Interval)
            Interval = setTimeout(function(){
                $("#weebox-notice-success").removeClass('saved');
                $("#weebox-notice-success").fadeOut(300);
            }, 1000)

        }

    }



    return response;

}, function(error) {

    $("#loader").stop().fadeOut(300);

    var msg = cancelMessage || error.message || ""
    console.log("ERRRRRROOOOOOOOOORRRR", msg)

    if( msg.indexOf('/export') >= 0 ){
        $("#weebox-export-inprogress").stop().hide();
    }

    if( error.response ){

        if( error.response.config.url.indexOf('/export') >= 0 ){
            $("#weebox-export-inprogress").stop().hide();
        }

        $("#weebox-notice .close").off().click(function(){ $(this).parent().removeClass('show'); });

        document.getElementById("weebox-notice").className = "";
        if(error.response.status == '401'){
            router.push("/login")
        }else{
            if(error.response.status == '500'){

                var errorMsg = error.response.data.message ? error.response.data.message : error.response.data.exception ? error.response.data.exception : '';
                document.getElementById("weebox-notice-message").innerHTML = errorMsg;
                document.getElementById("weebox-notice").className = "show";
                clearTimeout(window.intervalNotice);
                window.intervalNotice = setTimeout(function(){
                    document.getElementById("weebox-notice").className = "";
                }, 10000);

            }else{
                var messages = error.response.data.errors;
                var messages_string = [];
                //alert(error.response.data.message + ' ' + messages.join('\n\r'))
                for (var key in messages) {
                    // skip loop if the property is from prototype
                    if (!messages.hasOwnProperty(key)) continue;

                    var obj = messages[key];
                    for (var prop in obj) {
                        // skip loop if the property is from prototype
                        if(!obj.hasOwnProperty(prop)) continue;
                        messages_string.push(obj[prop])
                        //messages_string.push(key + " = " + obj[prop])
                        // your code
                        //alert(key + " = " + obj[prop]);
                    }
                }
                //alert(error.response.data.message + '\r' + messages_string.join('\r'))
                var errorMsg = error.response.data.message ? error.response.data.message : error.response.data.exception ? error.response.data.exception : '';
                document.getElementById("weebox-notice-message").innerHTML = errorMsg + '<br><br><ul><li>' + messages_string.join('</li><li>') + '</li></ul>';
                document.getElementById("weebox-notice").className = "show";
                clearTimeout(window.intervalNotice);
                window.intervalNotice = setTimeout(function(){
                    document.getElementById("weebox-notice").className = "";
                }, 5000);
            }
        }
        return Promise.reject(error.response);
    }

    //return Promise.reject({data:null});

});

export function Api(str) {

    $("#loader").stop().fadeIn(180);
    if(cancel){ cancel(cancelMessage); }
    return window.axios
}

let ApiExportPreviousRequests = [];
let newAxios = axios.create({});

newAxios.interceptors.request.use(function(config){

    let ApiExportCancel;

    config.headers['Authorization'] =  'Bearer ' + localStorage.getItem('token')
    config.headers['Accept'] =  'application/json'
    config.headers['X-WEEBOX-CLIENT'] =  localStorage.getItem('client')?localStorage.getItem('client'):document.head.querySelector("[name='X-WEEBOX-CLIENT']").content
    config.headers['X-WEEBOX-BACKEND'] =  true
    config.headers['Accept-Language'] =  'fr-CH'

    for(var i=0 ; i < ApiExportPreviousRequests.length ; i++)
    {
        if( ApiExportPreviousRequests[i].url == config.url){
            ApiExportPreviousRequests[i].cancel();
            ApiExportPreviousRequests.splice(i, 1);
            break;
        }
    }

    config.cancelToken = new CancelToken(function executor(c) {
        ApiExportCancel = c;

        ApiExportPreviousRequests.push({
            name: ExportFileName,
            url: config.url,
            index: ApiExportPreviousRequests.length,
            cancel: ApiExportCancel
        });
        /*
        $("#weebox-export-inprogress").stop().fadeIn();
        $("#weebox-export-inprogress [data-cancel]").unbind().click(function(){
            ApiExportCancel('manual');
        });
        */
        store.state.ApiExportPreviousRequests = ApiExportPreviousRequests;
    })

    return config;
})

newAxios.interceptors.response.use(function(response) {

    for(var i=0 ; i < ApiExportPreviousRequests.length ; i++)
    {
        if( ApiExportPreviousRequests[i].url == response.config.url){
            ApiExportPreviousRequests.splice(i, 1);
            break;
        }
    }

    return response;

}, function(error) {

    if (axios.isCancel(error)) {
        console.log("isCancel...", error.message)
        if( !isNaN(error.message) )
        {
            console.log("Remove...", error.message)
            ApiExportPreviousRequests.splice(error.message, 1);
        }
    }else{
        if( error.response ){

            for(var i=0 ; i < ApiExportPreviousRequests.length ; i++)
            {
                if( ApiExportPreviousRequests[i].url == error.response.config.url){
                    ApiExportPreviousRequests.splice(i, 1);
                    break;
                }
            }

            return Promise.reject(error.response);
        }else if( error.request )
        {

            alert("L'export a rencontré une erreur !")

            for(var i=0 ; i < ApiExportPreviousRequests.length ; i++)
            {
                if( ApiExportPreviousRequests[i].url == error.config.url){
                    ApiExportPreviousRequests.splice(i, 1);
                    break;
                }
            }
        }else if( error.message ){
            alert("L'export a rencontré une erreur: " + error.message)
        }
    }

});
let ExportFileName;
export function ApiExport(filename)
{
    ExportFileName = filename;
    newAxios.defaults.baseURL = window.apiUrl + '/' + store.state.scopes[store.state.scope.id].slug + '/v1/admin/';
    return newAxios;
}


// WEBPACK FOOTER //
// ./src/Api.js